import { useStoreReportes } from "../../paginas/Reportes/useStoreReportes";

export default function TipoProductoFiltro() {
  const tipoProducto = useStoreReportes((state) => state.TipoProducto);

  return (
    <label style={{ display: "flex", alignItems: "center", gap: 8, color: "#545454" }}>
      <span>Tipo de producto:</span>
      <select
        aria-label="Tipo de producto"
        value={tipoProducto}
        onChange={(event) => useStoreReportes.setState({ TipoProducto: event.target.value })}
        style={{ minWidth: 210, padding: "8px 10px", borderRadius: 6, border: "1px solid #bbb" }}
      >
        <option value="Todos">Todos</option>
        <option value="ProductoTerminado">Productos terminados</option>
        <option value="MateriaPrimaInsumo">Materias primas e insumos</option>
      </select>
    </label>
  );
}
